import IndexPagination from "@/components/IndexPagination";
import type { IndexPagination as IndexPaginationData } from "@/types";

export default function AuditsPagination({ pagination }: { pagination: IndexPaginationData }) {
  return (
    <IndexPagination
      id="pagination"
      pagination={pagination}
      itemLabel="audits"
      buildHref={(page) => `/audits?page=${page}`}
    />
  );
}
